export default {
  inModerationCount: (state) => state.inModerationCount || 0,
};
